import * as React from "react";
import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import { Search } from "lucide-react";

const inputVariants = cva(
  "font-medium file:text-foreground placeholder:text-muted-foreground selection:bg-brand-500/50 selection:text-primary-foreground dark:bg-input/30 flex w-full min-w-0 rounded-md bg-transparent text-sm outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 transform-gpu whitespace-normal break-words aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent/5 focus:bg-accent/10 placeholder:transition-colors placeholder:duration-200 focus:placeholder:text-muted-foreground/60 transition-[background-color,border-color,color,placeholder-color] duration-200 ease-in-out",
  {
    variants: {
      variant: {
        default: "h-4.5",
        filled:
          "bg-neutral-100 py-3 px-5 h-auto text-sm text-neutral-800 font-medium",
        search:
          "bg-neutral-100 pl-10 pr-5 py-3 text-neutral-700 placeholder-neutral-400 border border-transparent rounded-[8px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface InputProps
  extends React.ComponentProps<"input">,
    VariantProps<typeof inputVariants> {}

function Input({ className, type = "text", variant, ...props }: InputProps) {
  if (variant === "search") {
    return (
      <div className="relative w-full">
        <Search className="text-black-200 pointer-events-none absolute top-1/2 left-5 z-10 h-[16px] w-[16px] -translate-y-1/2" />
        <input
          type="search"
          data-slot="input"
          className={cn(inputVariants({ variant }), className)}
          {...props}
        />
      </div>
    );
  }

  return (
    <input
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Input };
